/**
 * @author salla.saishiva
 * @Date: 2023-09-14 11:30:49
 * @Last Modified by: salla.saishiva
 * @Last Modified time: 2023-09-14 16:30:49
*/

import React, { PureComponent } from 'react';
import { shape } from 'prop-types';
import { Container, HelmetWrapper } from '../../../../../components';
import { AppWrappperHOC } from '../../../../Root/HOC';
import { StyledBoardDirectors } from '../../StyledIPO';
import DirectorsProfileDetails from './DirectorsProfileDetails';
import { constants, utils } from '../../../../../devUtils';
import { BOARD_OF_DIRECTORS } from '../constants';


class DirectorsProfile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderSwitchDirectorsProfiles(type, history) {
    const { BOARD_OF_DIRECTORS_ENDPOINTS } = BOARD_OF_DIRECTORS;
    if (BOARD_OF_DIRECTORS_ENDPOINTS.includes(type)) {
      return <DirectorsProfileDetails type={type} />;
    }
    return utils.forceRedirect(history, { pathname: constants.BOARD_OF_DIRECTORS });
  }

  render() {
    const { match: { params: { type } = {} }, location, history } = this.props;
    return (
      <StyledBoardDirectors>
        <HelmetWrapper location={location} />
        <Container>
          {this.renderSwitchDirectorsProfiles(type, history)}
        </Container>
      </StyledBoardDirectors>
    );
  }
}

DirectorsProfile.propTypes = {
  match: shape({}).isRequired,
  location: shape({}).isRequired,
  history: shape({}).isRequired,
};

const component = AppWrappperHOC(DirectorsProfile);

export { DirectorsProfile };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/BoardOfDirectors/DirectorsProfile/index.jsx